import React, { useMemo } from 'react'
import { ScrollView, useWindowDimensions, View } from 'react-native'
import { StyleService, useStyleSheet } from '@style/service'
import {
  NORA_HOME_WALKTHROUGH_OVERLAY_COLOR,
  NORA_HOME_WALKTHROUGH_OVERLAY_OPACITY,
} from './constants'
import { NoraHomeActionStack } from './NoraHomeActionStack'
import { NoraHomeWalkthroughCloseButton } from './NoraHomeWalkthroughCloseButton'
import { getNoraHomeWalkthroughLayout } from './NoraHomeWalkthroughLayout'
import { NoraHomePageControl } from './NoraHomePageControl'
import { NoraHomeWalkthroughCard } from './NoraHomeWalkthroughCard'
import { StandaloneStep } from './types'
import { steps } from './steps'

export const StandaloneStepOverlay = ({
  step,
  stepIndex,
  isFinalStep,
  onClose,
  onNext,
  primaryActionLabel,
}: {
  step: StandaloneStep
  stepIndex: number
  isFinalStep: boolean
  onClose: () => void
  onNext: () => void
  primaryActionLabel?: string
}) => {
  const styles = useStyleSheet(themedStyles)
  const windowDimensions = useWindowDimensions()
  const layout = useMemo(() => getNoraHomeWalkthroughLayout(windowDimensions), [windowDimensions])

  return (
    <View style={styles.standaloneOverlay}>
      <View
        testID="nora-home-walkthrough-standalone-scrim"
        style={[
          styles.standaloneScrim,
          {
            backgroundColor: NORA_HOME_WALKTHROUGH_OVERLAY_COLOR,
            opacity: NORA_HOME_WALKTHROUGH_OVERLAY_OPACITY,
          },
        ]}
      />
      {!step.showSkip && <NoraHomeWalkthroughCloseButton onPress={onClose} />}
      <ScrollView
        style={styles.standaloneScroll}
        contentContainerStyle={[
          styles.standaloneContent,
          { paddingVertical: layout.standalonePadding },
        ]}
        showsVerticalScrollIndicator={false}
      >
        {!!step.actions?.length && <NoraHomeActionStack actions={step.actions} layout={layout} />}
        <NoraHomeWalkthroughCard
          step={step}
          stepIndex={stepIndex}
          stepCount={steps.length}
          showArrow={isFinalStep}
          isFinalStep={isFinalStep}
          primaryActionLabel={primaryActionLabel}
          layout={layout}
          onClose={onClose}
          onNext={onNext}
        />
      </ScrollView>
      <View style={[styles.standalonePageControl, { bottom: layout.pageControlBottom }]}>
        <NoraHomePageControl stepIndex={stepIndex} isOverlay />
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  standaloneOverlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  standaloneScrim: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  standaloneScroll: {
    width: '100%',
  },
  standaloneContent: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  standalonePageControl: {
    position: 'absolute',
    alignSelf: 'center',
  },
})
